export const enum IDP_APPS {
  COMMON = 'COMMON'
}

export const enum EndpointKeys {
  DASHBOARD_BFF_URL = 'DASHBOARD_BFF_URL',
  LOGIN_URL = 'LOGIN_URL',
  LOGOUT_URL = 'LOGOUT_URL',
  LOGOUT_TIMEOUT = 'LOGOUT_TIMEOUT',
  APP_AUTH_CONFIG_JSON = 'APP_AUTH_CONFIG_JSON'
}
